module.exports = __webpack_public_path__ + "common/icon-facebook-default-97f8ab199962e44bd42107bb1fb6ab08.svg";